import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/sale/target";

export default {
    /** 分页查询销售目标 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 查询销售目标详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),
    /** 保存销售目标（年目标自动拆分季度/月度） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除销售目标 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id: id}}),
    /** 销售目标统计 */
    stat: (data) => axios.get({url: `${PREFIX_URI}/stat`, data: data}),
    /** 销售业绩（汇总/目标进度/月度趋势 + 业绩排行） */
    performance: (data) => axios.get({url: `${PREFIX_URI}/performance`, data: data}),
    /** 销售业绩明细（抽屉） */
    performanceDetail: (data) => axios.get({url: `${PREFIX_URI}/performanceDetail`, data: data}),
};
